import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const NotificationsStyled = styled(Box, {
  position: 'fixed',
  left: '50%',
  transform: 'translateX(-50%)',
  textAlign: 'center',
  zIndex: '$notification',
});
